/**
 * What AutoScale recorded for a page once a decision was made about its scale
 */
export enum AutoScaleOutcome {
    AUTO_APPLIED = 'auto_applied',
    ACCEPTED = 'accepted',
    OVERRIDDEN = 'overridden',
    MANUAL = 'manual',
}

// same tolerance the backend uses to decide a page is on its named scale with no calibration
export const AUTO_SCALE_CALIBRATION_TOLERANCE = 0.005
